<template>
  <div>
      <el-form>
        <el-form-item>
         账户名称：
          <el-input style="width:50%" v-model="tu_username"></el-input>
        </el-form-item>
        <el-form-item>
          用户账号：
          <el-input style="width:50%" v-model="tu_phone"></el-input>
        </el-form-item>
        <el-form-item>
          用户密码：
          <el-input style="width:50%" v-model="tu_password" placeholder="请输入你要修改的密码"></el-input>
        </el-form-item>
        <el-form-item>
          角色状态：<el-switch
          v-model="tu_valid"
          active-color="#13ce66"
          inactive-color="#ff4949"
          >
        </el-switch>
        </el-form-item>
        <el-button @click="updateFromUser">保存</el-button>
      </el-form>
  </div>
</template>

<script>
  export default {
    inject:['reload'],
    name: 'AddAdmin',
    data(){
      return {
        tu_username:'',
        tu_password:'',
        tu_phone:'',
        tu_valid:true,
        tu_id:null
      }
    },
    mounted() {
      this.tu_username = this.$route.query.tu_username
      this.tu_phone = this.$route.query.tu_phone
      if(this.$route.query.tu_valid == 1){
        this.tu_valid = true
      }else{
        this.tu_valid = false
      }
      this.tu_id = this.$route.query.tu_id
    },
    methods:{
      updateFromUser(){
        this.$inbound.post({
          interfaceId: 'user/updateFromUser',
          data:{
            tu_id:this.tu_id,
            tu_username: this.tu_username,
            tu_phone: this.tu_phone,
            tu_password: this.tu_password,
            tu_valid: this.tu_valid
          }
        }).then(response => {
          window.location.reload()
        }).catch(error => {
          console.log(error)
        })
      },
      close (){
        this.$emit('close')
      }
    }

  }
</script>
